import { render, staticRenderFns } from "./CommunityYieldFarming.vue?vue&type=template&id=1c4f4148&scoped=true&"
import script from "./CommunityYieldFarming.vue?vue&type=script&lang=js&"
export * from "./CommunityYieldFarming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4f4148",
  null
  
)

export default component.exports